import { render, staticRenderFns } from "./ContactUsBulkModal.vue?vue&type=template&id=1295a7aa&scoped=true"
import script from "./ContactUsBulkModal.vue?vue&type=script&lang=js"
export * from "./ContactUsBulkModal.vue?vue&type=script&lang=js"
import style0 from "./ContactUsBulkModal.vue?vue&type=style&index=0&id=1295a7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295a7aa",
  null
  
)

export default component.exports